import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaStar, FaQuoteLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import API from '../api/axios';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    API.get('/testimonials').then(r => setTestimonials(r.data)).catch(() => {
      setTestimonials([
        { _id: '1', name: 'John Smith', position: 'CEO', company: 'TechCorp', rating: 5, comment: 'Exceptional work! Delivered our e-commerce platform on time with outstanding quality. Highly recommend!' },
        { _id: '2', name: 'Sarah Johnson', position: 'Marketing Director', company: 'GrowthHub', rating: 5, comment: 'Amazing SEO results! Our organic traffic increased by 300% within 3 months. Truly professional.' },
        { _id: '3', name: 'Mike Chen', position: 'Founder', company: 'StartupXYZ', rating: 5, comment: 'Built our entire web application from scratch. Clean code, great communication, and excellent results.' }
      ]);
    });
  }, []);

  if (testimonials.length === 0) return null;

  const next = () => setCurrent(c => (c + 1) % testimonials.length);
  const prev = () => setCurrent(c => (c - 1 + testimonials.length) % testimonials.length);
  const t = testimonials[current];

  return (
    <section className="testimonials section" id="testimonials">
      <div className="container">
        <div className="section-title"><h2>Client Reviews</h2><p>What my clients say about me</p></div>
        <div className="testimonial-slider">
          <button className="slider-btn prev" onClick={prev}><FaChevronLeft /></button>
          <motion.div className="testimonial-card" key={current}
            initial={{ opacity: 0, x: 50 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.4 }}>
            <FaQuoteLeft className="quote-icon" />
            <p className="testimonial-text">{t.comment}</p>
            <div className="testimonial-stars">
              {[...Array(5)].map((_, i) => <FaStar key={i} style={{ color: i < t.rating ? '#ffc107' : '#333' }} />)}
            </div>
            <div className="testimonial-author">
              <div className="author-avatar">{t.name?.charAt(0)}</div>
              <div>
                <h4>{t.name}</h4>
                <p>{t.position}{t.company ? `, ${t.company}` : ''}</p>
              </div>
            </div>
          </motion.div>
          <button className="slider-btn next" onClick={next}><FaChevronRight /></button>
        </div>
        <div className="slider-dots">
          {testimonials.map((_, i) => (
            <button key={i} className={`dot ${i === current ? 'active' : ''}`} onClick={() => setCurrent(i)} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
